export default "__VITE_ASSET__BKhJ4mWL__"